import React from "react";
import useSWR from "swr";
import { useSession } from "next-auth/react";
import {
    Box,
    Footer,
} from "grommet";
import { silentFetcher } from "../../../utils/errors";
import AppLayout from "../../../components/layouts/AppLayout";
import NotificationSubscriptionSection from "../../../components/settings/account/NotificationSubscriptionSection";
import SubMenu from "../../../components/SubMenu";
import { SETTINGS_PAGE_ACCOUNT_LINKS } from "../../../constants/Links";
import { SETTINGS } from "../../../constants/Permissions";
import { NOTIFICATIONS_HREF } from "../../../utils/permissions";

const NotificationsSettings = () => {
    const { data: session, status } = useSession();
    // Empty permissions means full access everywhere else in the app, so a session that has
    // not arrived yet must not read as one: it would flash the editor at someone who will
    // turn out to be restricted a moment later.
    const permissions = session?.user?.permissions || [];
    const canManageOthers = status === 'authenticated'
        && (permissions.length === 0 || permissions.includes(SETTINGS));

    // GET /companies/:id/teams is gated on settings access, so asking for it as a restricted
    // member returns 403, and silentFetcher's redirect would bounce them off the one Settings
    // page this feature opens to them. They have no use for the suggestions either: all they
    // can do is add themselves.
    const { data: teamData } = useSWR(
        canManageOthers ? `/api/settings/team` : null,
        silentFetcher, // team data is passed in as auto-suggestions, do not need to show error if it fails to load
        { revalidateOnFocus: false }
    );

    // Same reason the nav hides the other Settings tabs from them: General, Plans & Billing
    // and Audit Log all need settings access.
    const subMenuItems = canManageOthers
        ? SETTINGS_PAGE_ACCOUNT_LINKS
        : SETTINGS_PAGE_ACCOUNT_LINKS.filter(link => link.href === NOTIFICATIONS_HREF);

    return (
        <AppLayout title="Account" hasStickyDesktopPageHeader>
            <Box width={{ max: 'large' }} flex="grow">
                <SubMenu items={subMenuItems} />
                <NotificationSubscriptionSection team={teamData} canManageOthers={canManageOthers} />
                <Footer />
            </Box>
        </AppLayout>
    );
}


export default NotificationsSettings;
